import { useState } from 'react';
import { toast } from 'react-toastify';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { Button, Dialog } from 'components';
import { Form, Formik } from 'formik';
import { AuthContext } from 'hooks/useAuth';
import { providersService } from 'services';
import { useContextSelector } from 'use-context-selector';

export const DialogReopen = ({
  openDialogReopen,
  handleCloseDialogReopen,
  handleConfirmDialogReopen,
  reopenHide,
}) => {
  const user = useContextSelector(AuthContext, (context) => context.user);
  const [isLoading, setIsLoading] = useState(false);

  const reopenClient = async (props) => {
    setIsLoading(true);
    try {
      const { data } = await providersService.reopenClientRusubissionCasesOpen({
        idHide: reopenHide.idHide,
        usuario: user.name,
      });
      toast.success('Atualizado com Sucesso');
    } catch (error) {
      toast.error('Erro ao atualizar');
    } finally {
      setIsLoading(false);
      handleCloseDialogReopen();
    }
  };

  return (
    <Dialog open={openDialogReopen}>
      <Dialog.Title onClose={handleCloseDialogReopen}>Ocultar</Dialog.Title>
      <Dialog.Content>
        <Formik
          initialValues={{
            idHide: reopenHide.idHide,
            usuario: user.name,
          }}
        >
          {(props) => (
            <Form>
              <Grid container spacing={2}>
                <Grid item xs={12} lg={12}>
                  <Typography variant='h5' align='center' style={{ paddingBottom: '2rem' }}>
                    Deseja realmente exibir o reenvio do SAC?
                  </Typography>
                </Grid>
                <Grid item xs={12} lg={6}>
                  <Button
                    fullWidth
                    color='secondary'
                    loading={isLoading}
                    onClick={() => reopenClient(props)}
                  >
                    Sim
                  </Button>
                </Grid>
                <Grid item xs={12} lg={6}>
                  <Button fullWidth color='primary' onClick={handleCloseDialogReopen}>
                    Não
                  </Button>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Dialog.Content>
    </Dialog>
  );
};
